import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
    selector: 'canvas-backdrop',
    template: `<div (click)="Clicked.emit(Context)" class="backdrop">
    <ng-content></ng-content>
  </div>`,
    styles: [
        `
      :host, .backdrop{
        @apply w-full  h-full bg-black/25;
        z-index: 99999999999;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
      html{
        overflow: hidden;
      }
    `
    ],
    standalone: false
})
export class BackdropComponent {

  @Input() Context?: unknown;
  @Output() Clicked: EventEmitter<unknown | undefined> = new EventEmitter();

}
